import * as types from "../action/ActionType";
import { teamDetails } from "../store/IntialStore";
import type { AppAction, TeamDetails } from "../action/ActionType";

export default function TeamReducer(
  state: TeamDetails = teamDetails,
  action: AppAction
): TeamDetails {
  switch (action.type) {
    case types.UPDATE_COMPANY_LOGO:
      return { ...teamDetails, companyLogo: action.payload };
    default:
      return state;
  }
}
